<form role="form" name="actionForm" #actionForm="ngForm" (ngSubmit)="actionForm.valid && overrideSuspension()" novalidate>
    <div class="row">
        <!-- Loading section -->
        <div *ngIf="loading" class="loading-spinner text-center" [ngClass]="{'col-xs-6': allowOverride, 'col-xs-12': !allowOverride}">
            <span>Loading</span>
            <span class="fa fa-spinner fa-spin"></span>
        </div>

        <!-- Previous Job Details -->
        <div *ngIf="!loading" [ngClass]="{'col-xs-6': allowOverride, 'col-xs-12': !allowOverride}">
            <p [innerHTML]="displayHtmlText">
            </p>
            <p *ngIf="type == 'release'">Recruiters and Hiring Managers of '<span class='emerald'>{{releasedJobDetails.role}}</span>' from which the candidate was previously released</p>
            <p *ngIf="type == 'jobLeft'">Recruiters and Hiring Managers of '<span class='emerald'>{{releasedJobDetails.role}}</span>' that the candidate had left previously.</p>
            <h5 class="override-candidate-suspension-table-heading">Recruiters</h5>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let recruiter of releasedJobDetails.recruiters">
                        <td>{{recruiter.name}}</td>
                        <td>{{recruiter.email}}</td>
                    </tr>
                </tbody>
            </table>
            <h5 class="override-candidate-suspension-table-heading">Hiring Managers</h5>
            <p *ngIf="releasedJobDetails.hiringManagers == null" style="font-size: 0.9em">
                No Hiring Managers Available.
            </p>
            <table class="table table-bordered" *ngIf="releasedJobDetails.hiringManagers !== null">
                <thead>
                    <tr>
                    <th>Name</th>
                    <th>Email</th>
                </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let hiringManager of releasedJobDetails.hiringManagers">
                        <td>{{hiringManager.name}}</td>
                        <td>{{hiringManager.email}}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Enter recruiter/hiring manager details -->
        <div class="col-xs-6" *ngIf="allowOverride">
            <label class="modal-body-font-size">
                <p style="padding-left:3px">Enter the details of Hiring Manager/Recruiter allowing override</p>
            </label>
            <br>

            <div class="form-group col-xs-12" [ngClass]="{'has-error':(actionForm.submitted && firstName.invalid)}">
                <label for="firstName" class="control-label">
                    First Name <em> * </em> :
                </label>
                <input #firstName="ngModel" type="text" class="form-control access" id="firstName" name="firstName"
                    [(ngModel)]="recruiterDetails.firstName" required
                    [pattern]="MESSAGECONSTANTS.VALIDATIONPATTERNS.NAME" maxlength="100">
                <div class="error-message" *ngIf="actionForm.submitted && firstName.errors?.pattern">
                    <small class="error">{{MESSAGECONSTANTS.COMMONVALIDATIONS.FIRST_NAME}}</small>
                </div>
                <div class="error-message" *ngIf="actionForm.submitted && firstName.errors?.maxlength">
                    <small class="error">First Name can have maximum 100 characters.</small>
                </div>
            </div>
            <div class="form-group col-xs-12" [ngClass]="{'has-error':(actionForm.submitted && lastName.invalid)}">
                <label for="lastName" class="control-label">
                    Last Name <em> * </em> :
                </label>
                <input #lastName="ngModel" type="text" class="form-control access" id="lastName" name="lastName"
                    [(ngModel)]="recruiterDetails.lastName" required
                    [pattern]="MESSAGECONSTANTS.VALIDATIONPATTERNS.NAME" maxlength="100">
                <div class="error-message" *ngIf="actionForm.submitted && lastName.errors?.pattern">
                    <small class="error">{{MESSAGECONSTANTS.COMMONVALIDATIONS.FIRST_NAME}}</small>
                </div>
                <div class="error-message" *ngIf="actionForm.submitted && lastName.errors?.maxlength">
                    <small class="error">Last Name can have maximum 100 characters.</small>
                </div>
            </div>
            <div class="form-group col-xs-12" [ngClass]="{'has-error':(actionForm.submitted && email.invalid)}">
                <label for="email" class="control-label">Email
                    <em> * </em> :
                </label>
                <input #email="ngModel" type="text" class="form-control access" id="email" name="email"
                    placeholder="example@example.com" [(ngModel)]="recruiterDetails.recruiterEmail"
                    [pattern]="MESSAGECONSTANTS.VALIDATIONPATTERNS.EMAIL" required>
                <span class="help-block">ex. example@example.com</span>
                <div class="error-message" *ngIf="actionForm.submitted && email.invalid && email.errors?.pattern">
                    <small class="error">
                        {{MESSAGECONSTANTS.COMMONVALIDATIONS.NOT_VALID_EMAIL}}
                    </small>
                </div>
            </div>
            <div class="form-group col-xs-12" [ngClass]="{'has-error':(actionForm.submitted && note.invalid)}">
                <label>Note <em> * </em></label>
                <!-- Voice Input -->
                <div class="mb-2">
                    <app-voice-input
                        (transcriptReady)="onVoiceTranscript($event)"
                        sourceScreen="CANDIDATE"
                        [candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
                        [company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
                        [requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
                        [jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null">
                    </app-voice-input>
                </div>
                <textarea #note="ngModel" name="note" class="form-control"
                    style="height: 100px; width: 100%;resize: none;" maxlength="503"
                    [(ngModel)]="recruiterDetails.overrideNote" required>
                </textarea>
                <div class="error error-gap" *ngIf="actionForm.submitted">
                    <small *ngIf="note.errors?.required"><em>*</em>
                        Note is required
                    </small>
                </div>
                <!-- Formalize Text -->
                <app-formalize-comment
                    [inputText]="recruiterDetails.overrideNote"
                    (outputText)="receiveFormalizedComment($event)"
                    sourceScreen="CANDIDATE"
                    [candidate]="formalizeActivityPayload ? formalizeActivityPayload.candidate : null"
                    [company]="formalizeActivityPayload ? formalizeActivityPayload.company : null"
                    [requisition]="formalizeActivityPayload ? formalizeActivityPayload.requisition : null"
                    [jobMatch]="formalizeActivityPayload ? formalizeActivityPayload.jobMatch : null">
                </app-formalize-comment>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-xs-12 text-right">
            <div class="clearfix" *ngIf="allowOverride">
                <button type="button" class="btn btn-danger mr-2" [disabled]="overridingFlag" (click)="cancel()">Cancel</button>
                <button type="submit" class="btn btn-success" [disabled]="overridingFlag">
                    <span *ngIf="!overridingFlag">Override</span>
                    <span *ngIf="overridingFlag">Overriding...</span>
                </button>
            </div>
            <div class="clearfix" *ngIf="!allowOverride">
                <button type="button" class="btn btn-primary" (click)="cancel()">Ok</button>
            </div>
        </div>
    </div>
</form>
